import { Box, Typography, Button } from '@mui/material';
export function NotFound() {
  return (
    <Box sx={{ p: 4, textAlign: 'center' }}>
      <Typography variant="h4">404 — Page not found</Typography>
      <Button href="/" sx={{ mt: 2 }}>Go home</Button>
    </Box>
  );
}
